import { gql } from '@apollo/client';

export const OPEN_SALE_POOL_LOAN_TABLE = gql`
  mutation OpenSalePoolLoanTable(
    $saleId: ID!
    $offeringId: ID!
    $piiNoticeAcknowledged: Boolean
    $piiNoticeVersion: String
    $viewAs: SaleBidderLevel
  ) {
    openSalePoolLoanTable(
      sale_id: $saleId
      offering_id: $offeringId
      pii_notice_acknowledged: $piiNoticeAcknowledged
      pii_notice_version: $piiNoticeVersion
      view_as: $viewAs
    ) {
      __typename
      view_id
      protected
      level
      sale_key
      pool_number
      offering_name
      viewer_name
      expires_at
      opened_at
    }
  }
`;

export const LOG_SALE_POOL_LOAN_TABLE_EVENT = gql`
  mutation LogSalePoolLoanTableEvent(
    $viewId: ID!
    $kind: SalePoolLoanTableEventKind!
    $count: Int!
  ) {
    logSalePoolLoanTableEvent(view_id: $viewId, kind: $kind, count: $count)
  }
`;
